import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export const plannerApi = {
  getSettings: () => axios.get(`${API}/tour-planner/settings`, auth()),
  updateSettings: (data) => axios.put(`${API}/tour-planner/settings`, data, auth()),

  listRooms: (includeArchived = false) =>
    axios.get(`${API}/tour-planner/rooms?includeArchived=${includeArchived}`, auth()),
  createRoom: (data) => axios.post(`${API}/tour-planner/rooms`, data, auth()),
  updateRoom: (id, data) => axios.put(`${API}/tour-planner/rooms/${id}`, data, auth()),
  archiveRoom: (id) => axios.post(`${API}/tour-planner/rooms/${id}/archive`, {}, auth()),
  deleteRoom: (id) => axios.delete(`${API}/tour-planner/rooms/${id}?confirm=true`, auth()),

  listTours: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return axios.get(`${API}/tour-planner/tours${qs ? `?${qs}` : ""}`, auth());
  },
  createTour: (data) => axios.post(`${API}/tour-planner/tours`, data, auth()),
  updateTour: (id, data) => axios.put(`${API}/tour-planner/tours/${id}`, data, auth()),
  cancelTour: (id) => axios.post(`${API}/tour-planner/tours/${id}/cancel`, {}, auth()),
  listArchive: () => axios.get(`${API}/tour-planner/tours/archive`, auth()),
  deleteTour: (id) => axios.delete(`${API}/tour-planner/tours/${id}?confirm=true`, auth()),
  sendReminderNow: (id, data) => axios.post(`${API}/tour-planner/tours/${id}/send-reminder`, data, auth()),

  // Stage 2 — Accurate Live Ratios
  getLiveRatios: () => axios.get(`${API}/tour-planner/ratios/live`, auth()),

  // Stage 3 — Transitions & Future Planning
  getTransitions: () => axios.get(`${API}/tour-planner/transitions`, auth()),
  listWithdrawalPlans: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return axios.get(`${API}/tour-planner/withdrawal-plans${qs ? `?${qs}` : ""}`, auth());
  },
  createWithdrawalPlan: (data) => axios.post(`${API}/tour-planner/withdrawal-plans`, data, auth()),
  deleteWithdrawalPlan: (id) => axios.delete(`${API}/tour-planner/withdrawal-plans/${id}`, auth()),
  getProjectedRatios: (date) => axios.get(`${API}/tour-planner/ratios/projected?date=${date}`, auth()),

  // Hero Banner Photos
  listHeroImages: () => axios.get(`${API}/tour-planner/hero-images`, auth()),
  uploadHeroImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/tour-planner/hero-images`, fd, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
  },
  updateHeroImage: (id, data) => axios.patch(`${API}/tour-planner/hero-images/${id}`, data, auth()),
  deleteHeroImage: (id) => axios.delete(`${API}/tour-planner/hero-images/${id}`, auth()),
  getHeroImageBlob: (id) => axios.get(`${API}/tour-planner/hero-images/${id}/file`, { ...auth(), responseType: "blob" }),
};
